function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1178_4806)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M55.49 38.53C55.23 38.53 54.96 38.5 54.7 38.45C52.53 38.01 51.13 35.9 51.57 33.74C51.86 32.31 52 30.84 52 29.37C52 19.79 45.88 11.38 36.77 8.44002C34.67 7.76002 33.52 5.51002 34.19 3.40002C34.87 1.30002 37.12 0.150016 39.23 0.820016C51.65 4.84002 60 16.31 60 29.37C60 31.37 59.8 33.37 59.41 35.32C59.03 37.22 57.36 38.53 55.49 38.53Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30 59.37C22.46 59.37 15.26 56.56 9.70998 51.46C8.07998 49.96 7.97998 47.43 9.46998 45.81C10.97 44.19 13.5 44.08 15.12 45.57C19.19 49.31 24.47 51.37 30 51.37C35.53 51.37 40.85 49.3 44.92 45.53C46.54 44.03 49.07 44.13 50.57 45.75C52.07 47.37 51.97 49.9 50.35 51.4C44.79 56.54 37.56 59.36 30 59.36V59.37Z",
  fill: "#D2D6DB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.51999 38.6C2.65999 38.6 0.98999 37.29 0.59999 35.4C0.19999 33.43 -0.0100098 31.4 -0.0100098 29.38C-9.76585e-06 16.31 8.34999 4.84001 20.77 0.820006C22.87 0.140006 25.13 1.29001 25.81 3.40001C26.49 5.50001 25.34 7.76001 23.23 8.44001C14.12 11.38 7.99999 19.8 7.99999 29.37C7.99999 30.86 8.14999 32.35 8.44999 33.8C8.88999 35.97 7.48999 38.08 5.32999 38.52C5.05999 38.57 4.78999 38.6 4.52999 38.6H4.51999Z",
  fill: "#D2D6DB"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1178_4806"
}, /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 58.74,
  fill: "white",
  transform: "translate(0 0.630005)"
})));

function SvgProposed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposed);
export default __webpack_public_path__ + "static/media/proposed.00a4290a.svg";
export { ForwardRef as ReactComponent };